import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './LoanOffer.scss'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import creditDecisionServices from 'services/creditDecisionServices'
import getApplicationServices from 'services/getApplicationServices'
import documentServices from 'services/documentServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'
import CalculatorLt from './Calculator/CalculatorLt'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'
import CreditDecisonRunning from 'components/application-blocks/common-blocks/CreditDecisonRunning/CreditDecisonRunning'

const LoanOfferLt = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext
	)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<Error | any>()
	const [disabled, setDisabled] = useState<boolean>(true)
	const [spouseBetterOffer, setSpouseBetterOffer] = useState<boolean>(false)
	const applicationId = loanApplication.applicationData?.loanNumber!

	useEffect(() => {
		getApplicationInformation(applicationId)
	}, []) //eslint-disable-line

	const updateLoanData = async () => {
		try {
			await creditDecisionServices
				.updateLoanDataMulticash(
					applicationId,
					{
						amount: loanApplication.updateApplicationData?.loanData
							?.amount!,
						repaymentPeriod:
							loanApplication.updateApplicationData?.loanData
								?.repaymentPeriod!,
					},
					t
				)
				.then(async (response) => {
					if (response?.status === 200) {
						await getApplicationInformation(applicationId).then(
							() => {
								dispatchMsp({
									type: MSP_ACTIONS.SET_INDEX,
									payload: {
										index: msp.index + (spouseBetterOffer ? 2 : 1),
									},
								})
							}
						)
					}
				})
		} catch (error) {
			console.warn(error)
			setError(error)
			setLoading(false)
		}
	}

	const getApplicationInformation = async (applicationId: number) => {
		setLoading(true)
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
			await documentServices
				.getDownloadDocuments(applicationId.toString(), t)
				.then((response) => {
					loanApplication.setDocumentData(response)
				})
		} catch (error) {
			console.warn(error)
			setError(error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (
			!loanApplication.updateApplicationData?.loanData
				?.maxInstalmentWarning 
		) {
			setDisabled(false)
		} else {
			setDisabled(true)
		}
	}, [
		loanApplication.updateApplicationData?.loanData
	])

	useEffect(() => {
		if(!loanApplication.applicationData?.signingUrls?.spouseConsent?.url)
			setSpouseBetterOffer(loanApplication.applicationData?.offer?.hasSpouseBetterOffer ?? false)

		if(loanApplication.applicationData?.lifeCycleStatus === LifeCycleStatus.CreditDecisionInvestigation)
			dispatchMsp({
				type: MSP_ACTIONS.RESET_STEPS,
			})

	}, [
		loanApplication
	])

	const involveSpouse = async () => {
			setLoading(true)
			setError(null)
			try {
				dispatchMsp({
					type: MSP_ACTIONS.SET_INDEX,
					payload: {
						index: msp.index + 1,
					},
				})
			} catch (error) {
				console.warn(error)
				setError(error)
				setLoading(false)
			}
		}

	return (
		<div className="loan-offer">
			{loading ? (
				<div className="col-spinner">
					<CircleSpinner />
				</div>
			) : (
				<>
					{loanApplication?.applicationData?.lifeCycleStatus === LifeCycleStatus.CreditDecisionRunning ? (
						<CreditDecisonRunning />
					) :
					(loanApplication.applicationData?.offer === undefined) || ((loanApplication.applicationData?.approvedAmount ?? 0) === 0) ? (
						<ErrorBox message={`${t('LoanInfoError')}`} />
					) : (
						<>
							{spouseBetterOffer ? (
								<InfoBox
									infoType="info-gray"
									css="spouse-better-offer-info"
									message={t('SpouseMayGiveBetterOfferText')}
								/>
							) : (
								<></>
							)}
							<CalculatorLt />
							{error ? (
								<ErrorBox message={t('ErrorMsg')} />
							) : null}
							<div className="loan-offer-next-button">
								{spouseBetterOffer ? (
									<>
										<button
											className="btn btn-primary involve-spouse"
											onClick={() => involveSpouse()}>
											{t('InvolveSpouse')}
										</button>
									</>
								) : (
									<></>
								)}
								<button
									className="btn btn-primary"
									disabled={disabled}
									onClick={() => updateLoanData()}>
									{t('Next')}
								</button>
							</div>
						</>
					)}
				</>
			)}
		</div>
	)
}

export default LoanOfferLt
